/**
 * DLGCameraAngle enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file DLGCameraAngle.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @see https://lucasforumsarchive.com/thread/165950-tsl-camera-tweaking-cutscenes-and-such#post-1
 * @enum
 */
export enum DLGCameraAngle {
  ANGLE_RANDOM = 0,
  ANGLE_SPEAKER = 1,
  ANGLE_SPEAKER_BEHIND_PLAYER = 2,
  ANGLE_SPEAKER_AND_PLAYER_SIDE = 3,
  ANGLE_ANIMATED_CAMERA = 4,
  ANGLE_FOCUS_PLAYER = 5,
  ANGLE_PLACEABLE_CAMERA = 6,
}